import { ApplicationInsightsService } from '@abb-procure/application-insights';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@abb-procure/constants';
import { SnackbarService } from '@abb-procure/snackbar';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService extends ErrorHandler {
  private readonly injector = inject(Injector);
  private readonly appInsightsService = inject(ApplicationInsightsService);

  private readonly environmentConfig: EnvironmentConfig =
    inject(ENVIRONMENT_CONFIG);

  /**
   * Display an error notification and track the error through Application
   * Insights.
   */
  handleError(error: Error): void {
    super.handleError(error);

    this.appInsightsService.trackException({ exception: error });

    if (this.environmentConfig.production) {
      return;
    }

    const snackbarService = this.injector.get(SnackbarService);
    const title = error.name !== 'Error' ? `: ${error.name}` : '';

    snackbarService.showErrorSnackbar({
      title: `Unhandled exception${title}`,
      text: error.message,
    });
  }
}
